/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S6_IntroInputs */

const tr_cerez_s6_intro = /** @type {(inputs: Cerez_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel yalnızca gerekli çerezleri kullanır. Çerez penceresi bir bilgilendirmedir; açık rıza veya kategori seçimi istemez. Tarayıcı kayıtlarını aşağıdaki yollarla yönetebilirsiniz:`)
};

const en_cerez_s6_intro = /** @type {(inputs: Cerez_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The panel uses only necessary cookies. The cookie window is a notice; it does not request consent or a category selection. You can manage browser records in the following ways:`)
};

const de_cerez_s6_intro = /** @type {(inputs: Cerez_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Panel verwendet nur notwendige Cookies. Das Cookie-Fenster ist ein Hinweis; es verlangt keine Einwilligung oder Kategorieauswahl. Die Browsereinträge können Sie auf folgenden Wegen verwalten:`)
};

const ru_cerez_s6_intro = /** @type {(inputs: Cerez_S6_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель использует только необходимые cookie. Окно cookie носит информационный характер и не запрашивает согласие или выбор категорий. Управлять записями браузера можно следующими способами:`)
};

/**
* | output |
* | --- |
* | "The panel uses only necessary cookies. The cookie window is a notice; it does not request consent or a category selection. You can manage browser records in ..." |
*
* @param {Cerez_S6_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s6_intro = /** @type {((inputs?: Cerez_S6_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S6_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s6_intro(inputs)
	if (locale === "de") return de_cerez_s6_intro(inputs)
	if (locale === "ru") return ru_cerez_s6_intro(inputs)
	return tr_cerez_s6_intro(inputs)
});